import "ace-builds/src-noconflict/mode-latex";

export class CustomHighlightRules extends window.ace.acequire(
    "ace/mode/text_highlight_rules"
).TextHighlightRules {
    constructor() {
        super();
        this.$rules = {
            "start" : [
                {
                    token: ["keyword","keyword","keyword"],
                    regex: "(Round )([0-9]*)(: )",
                    next: "stitches",
                    caseInsensitive: true
                },
                {
                    token: "keyword",
                    regex: "Repeat",
                    next: "repeats",
                    caseInsensitive: true
                },
                {
                    token: "empty_line",
                    regex: '^$'
                },
                {
                    token: "keyword",
                    regex: "Gauge:",
                    next: "gauge",
                    caseInsensitive: true
                },
                {
                    token: "keyword",
                    regex: "Cast\\s*On",
                    next: "caston",
                    caseInsensitive: true
                },
                {
                    defaultToken: "text"
                }
            ],
            "stitches": [
                {
                    token: ["string", "string", "string"],
                    regex: "([kp])([0-9]+)((tog)?)(\,)",
                    next: "stitches"
                },
                {
                    token: ["string", "string"],
                    regex: "(\s*[kp])([0-9]+)((tog)?$)",
                    next: "start"
                },
                {
                    token: ["string", "string"],
                    regex: "(\s*[kp])([0-9]+)((tog)?)",
                    next: "stitches"
                },
                {
                    token: ["constant"],
                    regex: "repeat\\s*[0-9]+\\s*times",
                    next: "start",
                    caseInsensitive: true
                },
                {
                    token: "number",
                    regex: "$",
                    next: "start"
                },
                {
                    defaultToken: "text"
                }
            ],
            "repeats": [
                {
                    token: ["keyword", "keyword"],
                    regex: "(Round )([1-9]*)",
                    caseInsensitive: true
                },
                {
                    token: ["keyword", "keyword"],
                    regex: "(Rounds )([0-9]+(?:, [0-9])*,? and [0-9]*)",
                    caseInsensitive: true
                },
                {
                    token: "number",
                    regex: "$",
                    next: "start"
                },
                {
                    token: ["constant"],
                    regex: "[0-9]+ more times",
                    caseInsensitive: true
                },
                {
                    defaultToken: "text",
                    next: "start"
                }
            ],
            "gauge": [
                {
                    defaultToken: "text",
                    next: "start"
                }
            ],
            "caston": [
                {
                    defaultToken: "text",
                    next: "start"
                }
            ]
        };
    }
}

export default class KnitMode extends window.ace.acequire("ace/mode/latex")
    .Mode {
    constructor() {
        super();
        this.HighlightRules = CustomHighlightRules;
    }
}